import { __awaiter, __generator } from "tslib";
import { logger } from '../logger';
export var registerDrift = function (analytics, options) {
    if (!window.drift) {
        return;
    }
    window.drift.on('emailCapture', function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var eventName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(payload.data && payload.data.email)) return [3 /*break*/, 3];
                    logger.debug('Received Drift email capture event');
                    return [4 /*yield*/, analytics.identify(null, {
                            email: payload.data.email,
                        })];
                case 1:
                    _a.sent();
                    eventName = options.eventName;
                    return [4 /*yield*/, analytics.track(eventName)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); });
};
//# sourceMappingURL=drift.js.map